module.exports = __webpack_public_path__ + "img/sixpackcarrier73.e4d51557.jpg";